<template>
  <div class="wave-animation" :style="{'width': width, 'height': height}">
    <div class="circle1 circle" :style="{'width': width, 'height': height}" :class="{'circle-stop': !play, 'circle-32': oneclose}"></div>
    <div class="circle2 circle" v-if="!oneclose" :style="{'width': width, 'height': height}" :class="{'circle-stop': !play, 'circle-32': oneclose}"></div>
    <div class="circle3 circle" :style="{'width': width, 'height': height}" :class="{'circle-stop': !play, 'circle-33': oneclose}"></div>
    <div class="circle4 circle" :style="{'width': width, 'height': height}" :class="{'circle-stop': !play, 'circle-34': oneclose}"></div>
  </div>
</template>

<script>
export default {
  name: 'waveAnimation',
  props: ['play', 'width', 'height', 'oneclose'],
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.wave-animation {
  $w: 200px;
  $h: 200px;
  width: $w;
  height: $h;
  position: relative;
  .circle {
    width: $w;
    height: $h;
    box-sizing: border-box;
    position: absolute;
    top: 0px;
    left:0px;
    border-radius: 50%;
    border: px2html(1px) solid #AFCCF2;
    opacity: 0;
  }
  @for $i from 1 through 4 {
    .circle#{$i} {
      animation: circle-append 2.5s cubic-bezier(0.6, 0.2, 1.0, 1.0);
      animation-delay: ($i)/2 + s;
      animation-iteration-count: infinite;
    }
    .circle-3#{$i} {
      animation: circle-append-2 3s cubic-bezier(0.6, 0.2, 1.0, 1.0);
      animation-delay: ($i)/1.1 + s;
      animation-iteration-count: infinite;
    }
  }

  .circle-stop {
    animation-iteration-count: unset;
    animation: unset;
  }

  @keyframes circle-append {
    from {
      opacity: 1;
      transform:translateZ(0) scale(1);
    }
    50% {
      opacity: 0.5;
      transform:translateZ(0) scale(1.1);
    }
    to {
      opacity: 0;
      transform:translateZ(0) scale(1.4);
    }
  }

  @keyframes circle-append-2 {
    from {
      opacity: 0;
      transform:translateZ(0) scale(1);
    }
    50% {
      opacity: 0.2;
      transform:translateZ(0) scale(1.2);
    }
    to {
      opacity: 0;
      transform:translateZ(0) scale(1.6);
    }
  }
}
</style>
